import React from 'react';

interface SubService {
  title: string;
  description: string;
  features: string[];
}

interface Service {
  id: string;
  title: string;
  description: string;
  icon: string;
  image: string;
  subServices: SubService[];
}

interface ServiceListSectionProps {
  introParagraph: string;
  services: Service[];
}

export const ServiceListSection: React.FC<ServiceListSectionProps> = ({ introParagraph, services }) => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <p className="text-lg text-gray-700 leading-relaxed">
            {introParagraph}
          </p>
        </div>

        <div className="space-y-20">
          {services.map((service, index) => (
            <div key={service.id} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
              <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                <div className="flex items-center space-x-3 mb-6">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-red-600 text-xl`}></i>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{service.title}</h2>
                </div>
                
                <p className="text-lg text-gray-600 mb-8">{service.description}</p>

                <div className="space-y-6">
                  {service.subServices.map((subService, subIndex) => (
                    <div key={subIndex} className="bg-white rounded-xl p-6 shadow-lg">
                      <h3 className="text-xl font-bold text-gray-900 mb-3">{subService.title}</h3>
                      <p className="text-gray-600 mb-4">{subService.description}</p>
                      <div className="grid grid-cols-2 gap-2">
                        {subService.features.map((feature, featureIndex) => (
                          <div key={featureIndex} className="flex items-center space-x-2">
                            <i className="ri-check-line text-green-600 text-sm"></i>
                            <span className="text-sm text-gray-700">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-auto rounded-2xl shadow-xl"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};